<template>
  <div class="page d-flex">
      <MenuComponent />
      <ProfileViewComponent />
  </div>
</template>


<script>
import MenuComponent from '@/components/user/layout/MenuComponent.vue';
import ProfileViewComponent from '@/components/user/viewComponent/profile/ProfileViewComponent.vue';

export default{
name: 'ProfileView',
  components:{
      MenuComponent,
      ProfileViewComponent
  }
}
</script>

<style >

</style>